<template>
    <nav class="navbar"
         :class="[
            {'navbar-expand-md': expand},
            {'navbar-transparent': transparent},
            {[`bg-${type}`]: type}
         ]">
        <div :class="containerClasses">
            <slot name="brand">
            <b-breadcrumb class="breadcrumb-custom" :items="breadcrumbItems"/>
            </slot>
            <navbar-toggle-button v-if="showToggleButton"
                                  :toggled="toggled"
                                  :target="contentId"
                                  @click.native.stop="toggled = !toggled">
                <span class="navbar-toggler-icon"></span>
            </navbar-toggle-button>

            <div class="collapse navbar-collapse"
                 :class="{show: toggled}"
                 :id="contentId"
                 v-click-outside="closeMenu">

                <slot :close-menu="closeMenu"></slot>
            </div>
        </div>
    </nav>
</template>
<script>
import NavbarToggleButton from './NavbarToggleButton';

export default {
  name: 'base-nav',
  components: {
    NavbarToggleButton
  },
  props: {
    type: {
      type: String,
      default: '',
      description: 'Navbar type (e.g default, primary etc)'
    },
    title: {
      type: String,
      default: '',
      description: 'Title of navbar'
    },
    contentId: {
      type: [String, Number],
      default: Math.random().toString(),
      description:
        'Explicit id for the menu. By default it\'s a generated random number'
    },
    containerClasses: {
      type: [String, Object, Array],
      default: 'container-fluid'
    },
    transparent: {
      type: Boolean,
      default: false,
      description: 'Whether navbar is transparent'
    },
    expand: {
      type: Boolean,
      default: false,
      description: 'Whether navbar should contain `navbar-expand-lg` class'
    },
    showToggleButton: {
      type: Boolean,
      default: true
    }
  },
  mounted () {
    this.breadcrumbItems = this.$route.meta.breadcrumb.map((el, _, self) => ({
      text: this.$t(el.lang),
      to: { name: el.name },
      active: el.name === self[self.length - 1]
    }))
  },
  watch: {
    $route () {
      this.breadcrumbItems = this.$route.meta.breadcrumb.map((el, _, self) => ({
        text: this.$t(el.lang),
        to: { name: el.name },
        active: el.name === self[self.length - 1]
      }))
    }
  },
  data() {
    return {
      toggled: false,
      breadcrumbItems: []
    };
  },
  methods: {
    closeMenu() {
      this.toggled = false;
    }
  }
}
</script>
<style scoped>
  .breadcrumb-custom {
    margin-bottom: 0 !important;
    text-transform: uppercase;
    font-weight: bold;
    background-color: inherit !important;
    padding: 0
  }
  /deep/ .breadcrumb-item {
    font-size: 15px;
    padding: 10px 10px !important;
    border-radius: 6px !important;
  }
  /*/deep/ .breadcrumb-item:first-child {*/
  /*  padding-right: 0 !important;*/
  /*}*/
  /deep/ .breadcrumb-item:hover {
    background-color: #F6F9FC !important;
  }
  .breadcrumb-custom a {
    color: #626262 !important;
  }
  /deep/ .breadcrumb-item+.breadcrumb-item::before,
  /deep/ .breadcrumb-custom .breadcrumb-item.active {
    color: #000000 !important;
    background-color: inherit !important;
  }
  /deep/ .breadcrumb-item+.breadcrumb-item::before {
  }
</style>



// WEBPACK FOOTER //
// src/components/template/BaseNav.vue